import React from 'react';
import { Shield, Eye, Heart, Lock, Zap, Users } from 'lucide-react';
export function WhyChooseUsSection() {
  const features = [{
    title: 'Responsabilidad',
    description: 'Cumplimos cada compromiso',
    icon: Shield
  }, {
    title: 'Transparencia',
    description: 'Informamos cada paso del proceso',
    icon: Eye
  }, {
    title: 'Atención Personalizada',
    description: 'Seguimiento individual para cada cliente',
    icon: Heart
  }, {
    title: 'Seguridad',
    description: 'Protegemos cada envío como si fuera nuestro',
    icon: Lock
  }, {
    title: 'Eficiencia',
    description: 'Optimizamos rutas y procesos',
    icon: Zap
  }, {
    title: 'Cercanía',
    description: 'Relaciones genuinas basadas en confianza',
    icon: Users
  }];
  return <section className="py-16 md:py-24 bg-[#F8F9FA]" data-id="element-176">
      <div className="container mx-auto px-4 md:px-6" data-id="element-177">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-[#1B2B5E]" data-id="element-178">
          ¿Por qué elegirnos?
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12" data-id="element-179">
          {features.map((feature, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-180">
              <div className="w-20 h-20 rounded-full bg-white shadow-md flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-[#F5A623] transition-all duration-300" data-id="element-181">
                <feature.icon size={32} className="text-[#1B2B5E]" data-id="element-182" />
              </div>
              <h3 className="text-xl font-bold text-[#1B2B5E] mb-3" data-id="element-183">
                {feature.title}
              </h3>
              <p className="text-gray-600" data-id="element-184">{feature.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}